import React, { MouseEvent } from "react";
import { flexRender, Row } from "@tanstack/react-table";
import { StyledCell } from "../../table.styles";
import { IColumnMeta, ITableProps } from "../../table.types";

function TableRowCells<T>({
    row,
    rowHeight,
    columnClassName = "",
}: Pick<ITableProps<T>, "rowHeight" | "columnClassName"> & { row: Row<T> }) {
    const getCellProps = (isActionColumn: boolean, cellClassName?: string) => {
        return {
            onClick: (e: MouseEvent<HTMLDivElement>) => {
                if (isActionColumn) e.stopPropagation();
            },
            className: cellClassName,
        };
    };
    return (
        <>
            {row
                .getVisibleCells()
                .map(({ id, column: { columnDef }, getContext }) => {
                    const {
                        align = "left",
                        cellClassName,
                        isActionColumn = false,
                    } = columnDef.meta as IColumnMeta<T>;
                    return (
                        <td key={id}>
                            <StyledCell
                                textAlign={align}
                                rowHeight={rowHeight}
                                className={columnClassName}
                            >
                                <div
                                    {...getCellProps(
                                        isActionColumn,
                                        cellClassName
                                    )}
                                >
                                    {flexRender(columnDef.cell, getContext())}
                                </div>
                            </StyledCell>
                        </td>
                    );
                })}
        </>
    );
}

export default TableRowCells;
